export default __webpack_public_path__ + "static/media/plusSquareSvg.e84f55a6.svg";